// frontend/src/pages/SentencesWrapper.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sentences from './Sentences';

export default function SentencesWrapper() {
    const { level } = useParams();
    const navigate = useNavigate();
    
    const currentLevel = parseInt(level);
    localStorage.setItem('level', level);
    return (
        <Sentences
            level={currentLevel}
            onValidate={() => {

                navigate(`/exercise/sentences/reward/${currentLevel}`);
            }}
        />
    );
}
